import { colors } from '@itandi/itandi-bb-ui';
import { Deal } from './Deal';
import { getOriginDealVendor } from './DealVendorCompany';

export type DealEstimationHeader = {
  id: number;
  status: DealEstimationHeaderStatus;
  createdBy: string;
  requestedAt: string;
  processedAt: string | null;
  count: number;
  totalAmountWithTax: number;
  staffName: string | null;
  vendorUserName: string | null;
};

type DealEstimationHeaderStatus =
  | 'draft'
  | 'request'
  | 'cancel'
  | 'accept'
  | 'reject'
  | 'rejected_by_system';

// 見積り作成の責任がどちらの会社にあるかを判定する関数
export const estimationRequestSide = (
  deal: Deal,
  companyType: 'client' | 'vendor'
): boolean => {
  if (companyType === 'client') {
    return !!getOriginDealVendor(deal)?.skipEstimation;
  }
  return !(getOriginDealVendor(deal)?.skipEstimation ?? true);
};

export const statusLabel = (
  status: Exclude<DealEstimationHeaderStatus, 'draft'>
): string => {
  switch (status) {
    case 'request':
      return '申請中';
    case 'cancel':
      return '取り下げ';
    case 'accept':
      return '承認';
    case 'reject':
    case 'rejected_by_system':
      return '棄却';
    default:
      return '';
  }
};

export const statusBackgroundColors = (
  status: Exclude<DealEstimationHeaderStatus, 'draft'>
): string => {
  switch (status) {
    case 'request':
      return colors['expressive-blue'];
    case 'accept':
      return colors['semantic-positive'];
    case 'cancel':
    case 'reject':
    case 'rejected_by_system':
      return colors['semantic-negative'];
    default:
      return '';
  }
};
